
























































































































































import { Component, Mixins } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import DatePicker from '@/components/shared/admin/Input/DatePicker.vue';
import DatePickersMethods from '@/mixins/DatePickersMethods.vue';
import FlexibleTable from '@/components/Tables/FlexibleTable.vue';
import EditPresentationParticipantData from '@/ts/EditPresentationParticipantData';
import PreviewEmailButton from '@/components/Admin/Layout/PreviewEmailButton.vue';
import { dateFormat, dateTimeFormat } from '@/ts/DefaultTableConfigs';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';
import NotifyMethods from '@/mixins/NotifyMethods.vue';
import { TableViewConfig } from '@/ts/interfaces/TableConfigTypes';

@Component({
    components: {
        DatePicker,
        FlexibleTable,
        PreviewEmailButton,
    },
})
export default class EditPresentation extends Mixins(DatePickersMethods, LocalizationMethods, NotifyMethods) {
    public tableEntity: string = 'EditPresentation';
    public messageToApplicantsEdit: string = '';
    public offerDeadlineDate: string = '';
    public offerMoveinDate: string = '';
    public offerPresentationDate: string = '';
    public datePickers: string[] = [
        'presentation',
        'movein',
        'deadline',
    ];

    constructor() {
        super();
    }

    get columns(): any {
        return [
            { name: 'id', label: this.$t('general.id', 'ID'), align: 'left', field: 'id', sortable: true, required: true },
            { name: 'createdAt', label: this.$t('general.application-date', 'Application date'), align: 'left', field: 'createdAt', required: false, sortable: true, filterType: 'date', dateFormat: dateTimeFormat,
                sort: (a: any, b: any) => {
                    const aTimestamp = a !== '' ? this.$moment(a, dateTimeFormat).valueOf() : 0;
                    const bTimestamp = b !== '' ? this.$moment(b, dateTimeFormat).valueOf() : 0;

                    return aTimestamp - bTimestamp;
                },
            },
            { name: 'interestedFrom', label: this.$t('general.application-interest-from', 'Interest from'), align: 'left', field: 'interestedFrom', sortable: true, required: false, filterType: 'date', dateFormat },
            { name: 'name', label: this.$t('general.name', 'Name'), align: 'left', field: 'name', sortable: true, required: false },
            { name: 'email', label: this.$t('general.email', 'E-mail'), align: 'left', field: 'email', sortable: true, required: false },
            { name: 'phone', label: this.$t('general.phone', 'Phone') , align: 'left', field: 'phone', sortable: true, required: false },
            { name: 'language', label: this.$t('general.language', 'Language'), align: 'left', field: 'language', sortable: true, required: false },
            { name: 'priority', label: this.$t('general.priority', 'Priority'), align: 'left', field: 'priority', sortable: true, required: false },
            { name: 'interested', label: this.$t('general.interested', 'Interested'), align: 'left', field: 'interested', sortable: true, required: false },
        ];
    }

    get defaultTableConfig(): TableViewConfig {
        return {
            visibleColumns: [
                'id',
                'createdAt',
                'interestedFrom',
                'name',
                'email',
                'phone',
                'priority',
                'interested',
            ],
        };
    }

    get currentEditPresentation() {
        return this.$store.getters['PresentationFlows/getCurrentEditPresentation'];
    }

    get tableData(): EditPresentationParticipantData[] {
        return this.$store.getters['PresentationFlows/getCurrentEditPresentationParticipants'];
    }

    public loadPreviewEmailOverlay(templateId: any ) {
        const data = {
            templateId,
            message: this.currentEditPresentation.custom_instructions,
            presentationId: this.currentEditPresentation.id,
            presentationDate: this.currentEditPresentation.presentation_time,
            deadlineDate: this.currentEditPresentation.answer_deadline,
            moveinDate: this.currentEditPresentation.move_in,
        };

        this.$store.dispatch(Actions.FETCH_TEMPLATE_RENDERER, data);
    }

    public presentationDeadlineReached(presentationId: number)  {
        this.$store.dispatch(Actions.PRESENTATION_DEADLINE_REACHED, presentationId);
    }

    public sendPresentationEditOffer(presentationId: number)  {
        this.messageToApplicantsEdit = this.currentEditPresentation.custom_instructions;
        this.offerDeadlineDate = this.currentEditPresentation.answer_deadline;
        this.offerMoveinDate = this.currentEditPresentation.move_in;
        this.offerPresentationDate = this.currentEditPresentation.presentation_time;

        if (this.currentEditPresentation.answer_deadline === '' || (!this.currentEditPresentation.no_presentation && this.currentEditPresentation.presentation_time === '')) {
            return this.notify(
                this.currentEditPresentation.no_presentation
                    ? 'deadline_date_is_required'
                    : 'deadline_and_presentation_dates_are_required',
                'warning',
            );
        }
        if (new Date().getTime() > new Date(this.currentEditPresentation.answer_deadline).getTime() || (!this.currentEditPresentation.no_presentation && new Date().getTime() > new Date(this.currentEditPresentation.presentation_time).getTime())) {
            return this.notify(
                this.currentEditPresentation.no_presentation
                    ? 'deadline_date_should_be_later_then_today'
                    : 'deadline_and_presentation_dates_should_be_later_then_today',
                'warning',
            );
        }

        this.$store.dispatch(Actions.SEND_PRESENTATION_EDIT_OFFER, {
            message: this.currentEditPresentation.custom_instructions,
            presentationId,
            presentationDate: this.currentEditPresentation.presentation_time,
            deadlineDate: this.currentEditPresentation.answer_deadline,
            moveinDate: this.currentEditPresentation.move_in,
        });
    }

    public cancel() {
        this.$store.commit(Mutations.SET_EDIT_PRESENTATION_VISIBILITY, false);
    }
}
